import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export enum SubscriptionOfferStatus {
  ACTIVE = 'active',
  INCOMPLETE = 'incomplete',
}

export enum OfferFrequency {
  ANNUALY = 'annualy',
  MONTHLY = 'monthly',
}

export type PublicOffer = {
  companyDomain: string;
  companyName: string;
  currency: string;
  planType: string;
  pricing: {
    isMonthlyEnabled: boolean;
    monthlyPriceInCents: null | number;
    yearlyPriceInCents: number;
  };
  status: SubscriptionOfferStatus;
};

export type OfferCheckoutSessionResponse = {
  clientSecret: null | string;
  hostedInvoiceUrl: null | string;
  pricing: { amountInCents: null | number; currency: string; frequency: OfferFrequency };
};

export type PendingSubscriptionOffer = {
  planType: string;
  slug: string;
};

// tenant: global — a subscription offer pre-dates its company (the company is created by the
// claim), so offer routes are keyed by public slug instead of companies/:companyId.
export const getSubscriptionOffer = (slug: string) =>
  ApiService.get<PublicOffer>({
    endpoint: BackendRoute.SUBSCRIPTION_OFFERS,
    routePath: [slug],
  });

export const useSubscriptionOffer = (slug?: string) =>
  useAppQuery<PublicOffer>({
    queryKey: [QueryKey.GET_SUBSCRIPTION_OFFER, slug],
    queryFn: () => getSubscriptionOffer(slug!),
    enabled: !!slug,
    retry: false,
  });
